<template>
    <div class="bm p-3">

        <div class="title">立即报名 抢占名额</div>
        <form class="form-horizontal" role="form">
            <div class="form-group">
                <label for="firstname" class="col-sm-2 control-label">姓名*</label>
                <div class="col-sm-12">
                    <input type="text" ref="fname" v-model.trim="username" class="form-control"
                           placeholder="请输入您的姓名">
                </div>
            </div>
            <div class="form-group">
                <label for="lastname" class="col-sm-2 control-label">电话*</label>
                <div class="col-sm-12">
                    <input type="text" ref="fphone" v-model="phone" class="form-control" placeholder="请输入手机号">
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 d-grid gap-2">
                    <button @click.prevent="submit" type="submit"
                            class="btn btn-danger zoom_animation rounded-pill">立即报名
                    </button>
                </div>
            </div>
            <div class="form-group">
                <slot></slot>
            </div>


        </form>
    </div>
</template>
<script>

import {ref} from 'vue'
import {showToast} from 'vant';
import {req} from "@/api/req";

export default {
    name: 'Bm',
    setup() {
        let username = ref('')
        let phone = ref('')
        let fname = ref(null)
        let fphone = ref(null)

        function submit() {

            let reg = /^1[0-9]{10}$/;
            let r = reg.test(phone.value)
            if (!username.value) {
                fname.value.focus();
                return showToast('请输入姓名！');
            }
            if (!r) {
                fphone.value.focus();
                return showToast('请输入正确的手机号码！');
            }
            req({
                user_name: username.value,
                phone: phone.value,
                purpose_school: 2,//世达
                source: 7,//来源世达品专
                type:1,//类型
            }).then(res => {
                username.value = '';
                phone.value = '';
                showToast(res.msg);
            }).catch(err => {
                showToast(err)
            })

        }

        return {
            username,
            phone,
            submit,
            fname,
            fphone
        }
    }

}
</script>
<style scoped>

@keyframes zoom {
    0% {

        transform: scale(1, 1.1);

    }
    50% {

        transform: scale(0.9, 1);

    }
    75% {

        transform: scale(1, 1.1);

    }
    100% {
        transform: scale(1, 1.1);

    }
}

.zoom_animation {
    animation-name: zoom;
    animation-duration: 3s;
    animation-iteration-count: infinite;
}

.bm {
    width: 100%;
    background: #0393da;
}

.form-horizontal, .form-horizontal button, .form-horizontal button:hover {
    color: #fff;

}

.form-group {
    padding: 10px;
}

.title {
    color: #fff;
    font-size: 2rem;
    text-align: center;
}
</style>